<template><PreviewShell viewer="teacher" /></template>

<script>
import PreviewShell from '../PreviewShell';

/**
 * @module TeacherCourseList
 * @desc 教师课程预览：复用课程中心看课壳，数据由 Teacher Preview API 提供。
 */
export default {
  name: 'TeacherCourseList',
  components: { PreviewShell }
};
</script>
